<template>
  <Modal
    v-model="config"
    class="modal-tips"
    :mask-closable="false"
    footer-hide
    width="1000"
    @on-cancel="cancel"
  >
    <div slot="header" class="modal-header">
      <span>{{ title }}</span>
      <!-- <img class="close-icon" src="@/assets/image/guanbi.png" alt="" srcset="" @click="cancel"> -->
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
      class="rule-content-area"
      :class="{ 'rule-content-area-height': !fullscreen }"
      v-html="content"
    ></div>
  </Modal>
</template>

<script>
export default {
  name: "ruleModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
  computed: {
    config: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    cancel() {
      this.config = false;
    },
  },
};
</script>

<style lang="less" scoped>
  :deep(.ivu-modal-header) {
    background-color: #3992E9;
    padding: 25px;
  }
.modal-header {
  width: 100%;
  position: relative;
  text-align: center;
  span {
    font-size: 18px;
    line-height: 25px;
    color: #fff;
  }
  .close-icon{
    position: absolute;
    right: 0px;
    width: 25px;
    height: 25px;
    cursor: pointer;
  }
  .fullscreen {
    position: absolute;
    right: 30px;
    cursor: pointer;
    color: #888;
    transition: color 0.3s;
    &:hover {
      color: #111;
    }
  }
}
.rule-content-area-height {
  max-height: 500px;
}
// 规则样式
:deep(.rule-content-area) {
  padding: 25px 30px;
  overflow-y: auto;
  .sub-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
    line-height: 40px;
    border-bottom: 1px dashed #ccc;
  }
  p {
    margin-bottom: 10px;
    color: #333;
  }
  .p-red {
    color: #fc461e;
  }
  h2 {
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 12px;
    border-bottom: #f1f1f1 dashed 1px;
  }
  i {
    color: #fc461e;
    font-style: normal;
  }
  .tips {
    color: #898989;
    padding-left: 20px;
  }
}
</style>
